import React, { FC, FormEvent, useState } from 'react';

import {
    PRIVACY_POLICY_LINK,
    PUBLIC_OFFER_LINK_EDI,
    PUBLIC_OFFER_LINK_EDO,
    PUBLIC_OFFER_LINK_KASSA,
} from 'lib/constants';
import { redirect } from 'lib/navigation';
import { getLocationQuery } from 'lib/url';
import { jt, t } from 'ttag';

import Button from '../ui/button/button';
import Checkbox from '../ui/checkbox/checkbox';
import Title from '../ui/title/title';

import auth from '../../services/auth';
import PageTitle from '../pageTitle/pageTitle';

import css from './acceptOffers.css';

/**
 *
 * @deprecated
 */
const AcceptOffers: FC<React.PropsWithChildren<unknown>> = () => {
    const [checked, setChecked] = useState<boolean>(true);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [error, setError] = useState<string>('');

    const onSubmitForm = async () => {
        setIsLoading(true);
        try {
            const { token = '' } = getLocationQuery(document.location);
            const resp = await auth.acceptOffersShortRegister({ token });
            if (resp.ok) {
                redirect(`${config.KASSA_HOST}/api/internal/auth-to-pos`);
            } else {
                setError(t`Виникла помилка.`);
            }
        } catch (err) {
            setError(err.message);
        } finally {
            setIsLoading(false);
        }
    };

    const handleSubmit = async (evt: FormEvent) => {
        evt.preventDefault();
        await onSubmitForm();
    };

    const edoLink = (
        <a
            href={PUBLIC_OFFER_LINK_EDO}
            rel="noopener noreferrer"
            target="_blank"
        >
            {t`Вчасно`}
        </a>
    );

    const ediLink = (
        <a
            href={PUBLIC_OFFER_LINK_EDI}
            rel="noopener noreferrer"
            target="_blank"
        >
            {t`Вчасно.EDI`}
        </a>
    );

    const kassaLink = (
        <a
            href={PUBLIC_OFFER_LINK_KASSA}
            rel="noopener noreferrer"
            target="_blank"
        >
            {t`Вчасно.Каса`}
        </a>
    );

    const policyLink = (
        <a href={PRIVACY_POLICY_LINK} rel="noopener noreferrer" target="_blank">
            {t`політикою конфіденційності`}
        </a>
    );

    return (
        <form onSubmit={handleSubmit} className={css.root}>
            <PageTitle>{t`Оферти`}</PageTitle>
            <Title>{t`Оферти`}</Title>
            <div className={css.offer}>
                <div className={css.checkbox}>
                    <Checkbox checked={checked} onChange={setChecked} />
                </div>
                <div>
                    {jt`Я погоджуюсь з офертою ${edoLink}, ${ediLink}, ${kassaLink} та ${policyLink}`}
                </div>
            </div>

            <Button
                type="submit"
                theme="cta"
                width="full"
                isLoading={isLoading}
                disabled={!checked}
            >
                {t`Прийняти оферти та зареєструватись`}
            </Button>
            {error && <div className={css.error}>{error}</div>}
        </form>
    );
};

export default AcceptOffers;
